import { Box } from "@material-ui/core";
import React from "react";
import { BreadcrumbPage } from "../../shared";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  boxLayout: {
    backgroundColor: "#fff",
    boxShadow: "1px 1px 4px 1px #e0e0e0",
    borderRadius: 8,
  },
}));

export default function Samplogic() {
  const classes = useStyles();
  const BreadcrumbList = [{ name: "Samplogic", url: "" }];
  return (
    <div>
      <Box pb={3} pt={0} mx={3} display="dlock">
        <BreadcrumbPage rows={BreadcrumbList} />
      </Box>
      <Box mx={3} className={classes.boxLayout}>
        <iframe
          id="myIframe"
          style={{ width: "100%", height: "700px" }}
          class="sam-iframe"
          src="https://samplogic.vpsveritas.com"
          name="vps"
          scrolling=" "
          frameborder="0"
          marginheight="0px"
          marginwidth="0px"
          allowfullscreen
        ></iframe>
      </Box>
    </div>
  );
}
